import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import bgHero from "../assets/bg-hero.jpg";
import bgServicios from "../assets/bg-servicios.jpg";
import {
  IMAGES,
  NAV_LINKS,
  FIGURES,
  SERVICIOS,
  PASOS,
  TIPOS_MEMBRESIA,
} from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <header>
      <div className="nav-inner">
        <a href="/" className="brand" onClick={close}>
          <Logo />
          <span className="brand-text">
            Contreras<span>&amp; Asociados PV</span>
          </span>
        </a>
        <div className={`nav-links${open ? " open" : ""}`} id="navLinks">
          <nav>
            <ul>
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={close}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <a href="/#contacto" className="btn btn-solid" onClick={close}>
            Agenda tu consulta
          </a>
        </div>
        <button
          className="burger"
          aria-label="Abrir menú"
          onClick={() => setOpen((v) => !v)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export const Hero = () => (
  <section className="hero" style={{ backgroundImage: `url(${bgHero})` }}>
    <div className="wrap hero-grid">
      <div>
        <div className="eyebrow">
          <span className="diamond">◆</span> PUERTO VALLARTA · DESPACHO JURÍDICO
        </div>
        <h1>
          Asesoría legal con <em>criterio</em>,<br />
          resultados con respaldo.
        </h1>
        <p className="lead">
          Contreras &amp; Asociados PV acompaña a personas, familias y empresas
          de la Bahía de Banderas en sus decisiones legales más importantes —
          con análisis riguroso y trato cercano.
        </p>
        <div className="hero-ctas">
          <a href="#contacto" className="btn btn-solid">
            Agenda tu consulta
          </a>
          <a href="#servicios" className="btn btn-outline">
            Conoce nuestros servicios
          </a>
        </div>
        <div className="hero-figures">
          {FIGURES.map((f) => (
            <div key={f.value}>
              <strong>{f.value}</strong>
              <span>{f.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="hero-photo">
        <img src={IMAGES.hero} alt="Análisis legal de contrato" />
        <div className="hero-caption">
          <strong>Análisis exhaustivo</strong>
          <p>
            Revisamos cada cláusula antes de actuar. Ninguna letra pequeña se
            nos escapa.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export const Servicios = () => (
  <section
    id="servicios"
    className="has-bg-servicios"
    style={{ backgroundImage: `url(${bgServicios})` }}
  >
    <div className="wrap">
      <div className="section-head">
        <div className="eyebrow">
          <span className="diamond">◆</span> ÁREAS DE PRÁCTICA
        </div>
        <h2>Servicios legales integrales</h2>
        <p>
          Cubrimos las áreas del derecho que con más frecuencia acompañan la
          vida de nuestros clientes en Puerto Vallarta y la Riviera Nayarit.
        </p>
      </div>
      <div className="servicios-grid">
        {SERVICIOS.map((s) => (
          <Link className="servicio-card" key={s.num} to={`/${s.slug}`}>
            <span className="servicio-num">{s.num}</span>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
            <span className="servicio-more">Ver más →</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

const MembresiasCopy = () => (
  <div className="mem-copy">
    <p>
      Puerto Vallarta y la Riviera Nayarit concentran una de las mayores
      incidencias de contratos de tiempo compartido del país. Muchos de estos
      contratos incluyen cláusulas abusivas, plazos de cancelación mal
      explicados o prácticas de venta agresivas — y eso puede jugar a tu favor.
    </p>
    <p>
      En Contreras &amp; Asociados PV analizamos tu contrato a fondo,
      identificamos las irregularidades y construimos la estrategia de salida
      que mejor se ajusta a tu caso, sin promesas vacías.
    </p>
    <p style={{ marginBottom: "8px" }}>
      <Link to="/cancelacion-timeshare" className="gold-link">
        Más sobre cancelación de timeshare →
      </Link>
    </p>
    <div className="pasos">
      {PASOS.map((p) => (
        <div className="paso" key={p.num}>
          <span className="paso-num">{p.num}</span>
          <div>
            <h4>{p.title}</h4>
            <p>{p.text}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const FormSuccess = () => (
  <div className="form-success">
    <h3>Tu información fue recibida.</h3>
    <p>
      Gracias por confiar en Contreras &amp; Asociados PV. Uno de nuestros
      abogados se pondrá en contacto contigo muy pronto.
    </p>
  </div>
);

const FormError = () => (
  <div className="form-error">
    <h3>No pudimos enviar tu solicitud.</h3>
    <p>
      Por favor intenta de nuevo o llámanos directamente al +52 33 4624 0169.
    </p>
  </div>
);

const FORM_FIELDS = [
  { name: "nombre", label: "Nombre completo", type: "text", full: true, required: true },
  { name: "correo", label: "Correo electrónico", type: "email", required: true },
  { name: "telefono", label: "Teléfono", type: "tel", required: true },
  { name: "compania", label: "Compañía de la membresía", type: "text", required: true },
  { name: "tipo", label: "Tipo de membresía", type: "select", required: true },
  {
    name: "temporada",
    label: "Temporada contratada",
    type: "text",
    placeholder: "Ej. Temporada alta, semana 32, flotante...",
    full: true,
  },
];

const FormField = ({ field }) => (
  <div className={`field${field.full ? " full" : ""}`}>
    <label htmlFor={field.name}>{field.label}</label>
    {field.type === "select" ? (
      <select id={field.name} name={field.name} required={field.required} defaultValue="">
        <option value="" disabled>
          Selecciona una opción
        </option>
        {TIPOS_MEMBRESIA.map((t) => (
          <option key={t}>{t}</option>
        ))}
      </select>
    ) : (
      <input
        type={field.type}
        id={field.name}
        name={field.name}
        required={field.required}
        placeholder={field.placeholder}
      />
    )}
  </div>
);

const LeadFormFields = ({ submitting }) => (
  <>
    <div className="form-row">
      {FORM_FIELDS.map((f) => (
        <FormField key={f.name} field={f} />
      ))}
    </div>
    <button
      type="submit"
      className="btn btn-gold form-submit"
      disabled={submitting}
    >
      {submitting ? "Enviando..." : "Enviar solicitud"}
    </button>
    <p className="form-note">
      Tu información es confidencial y solo se usará para contactarte sobre tu
      caso.
    </p>
  </>
);

const LeadForm = () => {
  const [status, setStatus] = useState("form"); // form | success | error
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const data = Object.fromEntries(new FormData(e.target).entries());
    try {
      await axios.post(`${API}/leads`, {
        nombre: data.nombre,
        correo: data.correo,
        telefono: data.telefono,
        compania: data.compania,
        tipo: data.tipo,
        temporada: data.temporada || "",
      });
      setStatus("success");
    } catch (err) {
      setStatus("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-card">
      {status === "form" && (
        <>
          <h3>Solicita tu evaluación gratuita</h3>
          <p>
            Cuéntanos sobre tu membresía y un abogado del despacho te contactará
            en menos de 24 horas.
          </p>
          <form onSubmit={handleSubmit}>
            <LeadFormFields submitting={submitting} />
          </form>
        </>
      )}
      {status === "success" && <FormSuccess />}
      {status === "error" && <FormError />}
    </div>
  );
};

export const Membresias = () => (
  <section className="membresias" id="membresias">
    <div className="wrap">
      <div className="section-head">
        <div className="eyebrow">
          <span className="diamond">◆</span> ESPECIALIDAD DEL DESPACHO
        </div>
        <h2>Cancelación de membresías vacacionales y timeshare</h2>
        <p>
          Si firmaste bajo presión, con información incompleta o simplemente ya
          no quieres seguir pagando una membresía que no usas, tienes opciones
          legales reales.
        </p>
      </div>
      <div className="mem-grid">
        <MembresiasCopy />
        <LeadForm />
      </div>
    </div>
  </section>
);
